import { Zone } from "@fairfleet/geotab";
import { GridFilterOperator } from "@mui/x-data-grid-pro";
import ZoneMultiSelectFilter from "../filter/ZoneSelectMultiFilter";
import i18n from "@/i18n";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";

export const ZoneFilterOperators: GridFilterOperator[] = [
  {
    label: i18n.t("faultOverview.zoneAnyFilter"),
    value: "isAnyOf",
    getApplyFilterFn: filterItem => {
      if (!filterItem || !filterItem.value || filterItem.value.length === 0) {
        return null;
      }
      return (_, row: DeviceStatusOverviewData): boolean => {
        const itemValues: string[] | undefined = row?.allZones?.map(z => z?.id);
        if (!itemValues) return false;
        return filterItem.value.some((value: Zone) => itemValues.includes(value.id));
      };
    },
    InputComponent: ZoneMultiSelectFilter,
  },
  {
    label: i18n.t("faultOverview.zoneNotAnyFilter"),
    value: "isNotAnyOf",
    getApplyFilterFn: filterItem => {
      if (!filterItem || !filterItem.value || filterItem.value.length === 0) {
        return null;
      }
      return (_, row: DeviceStatusOverviewData): boolean => {
        const itemValues: string[] | undefined = row?.allZones?.map(z => z?.id);
        if (!itemValues) return false;
        return !filterItem.value.some((value: Zone) => itemValues.includes(value.id));
      };
    },
    InputComponent: ZoneMultiSelectFilter,
  },
];
